import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { updateAuditTemplate } from "redux/actions/auditTemplate/auditTemplateUpdate";
import { loadAuditTemplate } from "redux/actions/auditTemplate/auditTemplateLoad";
import Button from "shared/components/buttons/Button";
import Icon from "shared/components/Icon";
import { ICONS } from "shared/components/Icon";
import InputText from "shared/components/inputs/InputText";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { snackbarSuccess } from "shared/redux/actions/Snackbar";
import uploadImage from "helpers/getPublicImageUrl";

import "./style.scss";

const Audit = () => {
    const useStyles = makeStyles({
        auditCheckbox: {
            color: '#006280',
            '&.Mui-checked': {
                color: '#006280',
            },
        },
    });

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { osbn } = useParams();
    const fileRef = useRef(null);
    const { control, handleSubmit, errors, watch } = useForm();

    const classes = useStyles();
    const { books } = useSelector(state => state.books);
    const { template } = useSelector(state => state.auditTemplate);
    const { current: organisation } = useSelector(state => state.organisation);

    const book = books[osbn];
    const [logoUrl, setLogoUrl] = useState(book?.cover);
    const [showAuditDetails, setShowAuditDetails] = useState(template?.isActive ?? false);

    useEffect(() => {
        setLogoUrl(template.logoUrl);
    }, []);


    useEffect(() => {
        if (book?.id) {
            dispatch(loadAuditTemplate(book.id));
        }
    }, [book?.id]);

    const onFileSelected = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setLogoUrl(URL.createObjectURL(file));

        try {

            const uploadedUrl = await uploadImage(file);
            setLogoUrl(uploadedUrl);

        } catch (err) {
            console.error("Upload failed", err);
        }
    };

    const updateAudit = async ({
        header,
        footer,
        title,
        subtitle,
        isActive,
    }) => {
        const showAuditStatus = isActive === undefined ? showAuditDetails : isActive;

        const templateData = {
            bookId: book.id,
            isActive: showAuditStatus,
            header: header ?? "",
            footer: footer ?? "",
            title: title ?? "",
            subtitle: subtitle ?? "",
            logoUrl,
            id: template.id ?? ""
        };

        dispatch(updateAuditTemplate(templateData));
        dispatch(snackbarSuccess("Audit template changes have been saved."));
    };

    const selectFile = () => {
        fileRef.current.click();
    };
    const renderCover = () => {
        return (
            <div className="cover-logo">
                <input
                    className="hidden-file"
                    type="file"
                    onChange={onFileSelected}
                    ref={fileRef}
                />
                <img src={logoUrl || require("assets/img/books-placeholder.png")} alt="Cover" />
                <div className="image-change">
                    <Icon
                        name={ICONS.CAMERA}
                        onClick={selectFile}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="section-general">
            <h2>{t("book.audit.template.name")}</h2>
            <div className="divider" />
            <div className="inline-toggle-container">
                <div className="inline-label">
                    {t("book.audit.checkbox.description")}
                </div>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showAuditDetails}
                            classes={{ root: classes.auditCheckbox }}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setShowAuditDetails(checked);
                                const { header, footer, title, subtitle } = watch();
                                updateAudit({
                                    header,
                                    footer,
                                    title,
                                    subtitle,
                                    isActive: checked,
                                    logoUrl,
                                    id: template.id,
                                });
                            }}
                        />
                    }
                    label={showAuditDetails ? "Yes" : "No"}
                />
            </div>
            {showAuditDetails && (
                <>
                    <div className="cols-m">
                        {renderCover()}
                        <div className="col">
                            <InputText
                                name="header"
                                label={t("book.audit.header")}
                                defaultValue={template?.header || ""}
                                control={control}
                                rules={{ required: true }}
                                error={errors.label}
                                dataTestId="label"
                            />
                            <InputText
                                name="footer"
                                label={t("book.audit.footer")}
                                defaultValue={template?.footer || ""}
                                control={control}
                                rules={{ required: true }}
                                error={errors.author}
                                dataTestId="author"
                            />
                            <InputText
                                name="title"
                                label={t("book.audit.title")}
                                defaultValue={template?.title || ""}
                                control={control}
                                rules={{ required: true }}
                                error={errors.author}
                                dataTestId="author"
                            />
                            <InputText
                                name="subtitle"
                                label={t("book.audit.subtitle")}
                                defaultValue={template?.subtitle || ""}
                                control={control}
                                rules={{ required: true }}
                                error={errors.author}
                                dataTestId="author"
                            />
                        </div>
                    </div>
                    <div className="divider" />
                    <Button
                        label={t("button.save.label")}
                        onClick={handleSubmit(updateAudit)}
                    />
                </>
            )}


        </div>
    );
};

export default Audit;